import BaseModal from "../../BaseComponents/BaseModal/BaseModal";
import styles from "./ViewRefundModal.module.css";

const ViewRefundModal = ({ open, onClose, refund, refundType = "supplier" }) => {
  if (!refund) return null;

  const isSupplier = refundType === "supplier";

  const getStatusClass = (status) => {
    switch (status) {
      case "Completed":
        return styles.statusCompleted;
      case "Pending":
        return styles.statusPending;
      case "Failed":
        return styles.statusFailed;
      default:
        return "";
    }
  };

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={`${isSupplier ? "Supplier" : "Client"} Refund Details`}
      width="560px"
      footer={
        <button className={styles.closeBtn} onClick={onClose}>
          Close
        </button>
      }
    >
      <div className={styles.detailGrid}>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Reference</span>
          <span className={styles.detailValue + " " + styles.mono}>{refund.reference}</span>
        </div>

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{isSupplier ? "Supplier" : "Customer"}</span>
          <span className={styles.detailValue}>
            {isSupplier ? refund.supplierName : refund.customerName}
          </span>
        </div>

        {isSupplier && refund.supplierEmail && (
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Email</span>
            <span className={styles.detailValue + " " + styles.dimmed}>{refund.supplierEmail}</span>
          </div>
        )}

        {!isSupplier && refund.customerEmail && (
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Email</span>
            <span className={styles.detailValue + " " + styles.dimmed}>{refund.customerEmail}</span>
          </div>
        )}

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Booking Ref</span>
          <span className={styles.detailValue + " " + styles.booking}>{refund.bookingRef}</span>
        </div>

        {isSupplier && refund.componentType && (
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Component</span>
            <span className={styles.detailValue}>{refund.componentType}</span>
          </div>
        )}

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Reason</span>
          <span className={styles.detailValue}>
            <span className={styles.reasonTag}>{refund.reason}</span>
          </span>
        </div>

        <div className={styles.divider} />

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Amount</span>
          <span className={styles.detailValue + " " + styles.amount}>
            €{refund.amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </div>

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Date</span>
          <span className={styles.detailValue}>{refund.date}</span>
        </div>

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Account</span>
          <span className={styles.detailValue}>{refund.account || "—"}</span>
        </div>

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Payment Method</span>
          <span className={styles.detailValue}>{refund.paymentMethod || "—"}</span>
        </div>

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Status</span>
          <span className={styles.detailValue}>
            <span className={`${styles.statusTag} ${getStatusClass(refund.status)}`}>
              {refund.status}
            </span>
          </span>
        </div>

        {(refund.airlinePnr || refund.supplierReferenceNo || refund.transactionId) && (
          <>
            <div className={styles.divider} />
            {refund.airlinePnr && (
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>Airline PNR</span>
                <span className={styles.detailValue + " " + styles.mono}>{refund.airlinePnr}</span>
              </div>
            )}
            {refund.supplierReferenceNo && (
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>Supplier Ref No</span>
                <span className={styles.detailValue + " " + styles.mono}>{refund.supplierReferenceNo}</span>
              </div>
            )}
            {refund.transactionId && (
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>Transaction ID</span>
                <span className={styles.detailValue + " " + styles.mono}>{refund.transactionId}</span>
              </div>
            )}
          </>
        )}

        {refund.notes && (
          <>
            <div className={styles.divider} />
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Notes</span>
              <span className={styles.detailValue + " " + styles.notes}>{refund.notes}</span>
            </div>
          </>
        )}
      </div>
    </BaseModal>
  );
};

export default ViewRefundModal;